<template>
  <div class="content-layout-fixer">
    <VueOverlay v-if="isChatbotInitializing" />
    <div class="content-wrapper">
      <div class="top">
        <div class="chef"></div>
        <div class="title">
          Merhaba, Ben Şef! <br />
          Bugün sana nasıl yardımcı olabilirim?
        </div>
      </div>
      <iframe
        v-if="shouldRenderChatbot"
        :src="`${iframeSrc}`"
        height="512"
        width="650"
        scrolling="no"
        style="border: 0;"
      />
    </div>
  </div>
</template>

<script>
import VueOverlay from '@/components/shared/VueOverlay/VueOverlay.vue';
import { mapState } from 'vuex';
import storageProps from '@/mixins/storageProps.js';
import {
  hideChatbotWidget,
  initChatbot,
  hasChatbotRuntimeData,
  showChatbotWidget,
} from '@/utils/chatbotHelper';
export default {
  name: 'Chatbot',
  mixins: [storageProps],
  components: { VueOverlay },
  data() {
    return {
      iframeSrc: null,
      shouldRenderChatbot: false,
    };
  },
  async created() {
    hideChatbotWidget();
    if (!this.currentUser?.isImageRecognitionUser) {
      this.iframeSrc = this.getIframeSrc();
      if (hasChatbotRuntimeData()) {
        this.shouldRenderChatbot = true;
      } else {
        try {
          await initChatbot(this.$store);
          this.shouldRenderChatbot = true;
        } catch (error) {
          console.warn('[Chatbot] init failed.', error);
          this.iframeSrc = null;
        }
      }
    }
  },
  computed: {
    ...mapState('app', ['isChatbotInitializing']),
  },
  methods: {
    getIframeSrc() {
      const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
      const isDevOrQaEnvironment = apiBaseUrl.includes('qa') || apiBaseUrl.includes('dev');

      const environmentPrefix = isDevOrQaEnvironment
        ? apiBaseUrl.includes('qa')
          ? 'qa'
          : 'dev'
        : 'pmaktif';

      const iframeSrc = isDevOrQaEnvironment
        ? `https://${environmentPrefix}.pmaktiftr-${environmentPrefix}.aws.pmicloud.biz/chatbot.html`
        : `https://${environmentPrefix}.com/chatbot.html`;

      console.log({ iframeSrc });

      return iframeSrc;
    },
  },
  mounted() {
    document.documentElement.style.setProperty('--mb-mwc-font-stack', 'Roboto, sans-serif');
  },
  beforeDestroy() {
    showChatbotWidget();
  },
};
</script>

<style lang="scss" scoped>
.content-layout-fixer {
  height: calc(100vh - 100px);
}
.content-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
iframe {
  width: 500px;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  flex: 1;
}
.top {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  .chef {
    height: 80px;
    width: 80px;
    background-image: url('~@/assets/images/kulaklik-chatbot-buyuk.png');
    background-position: top center;
    background-size: 100%;
    border-radius: 50%;
  }
  .title {
    font-size: 16px;
    letter-spacing: 1px;
    margin-top: 10px;
    text-align: center;
  }
}
</style>
